class PaymentContractItem {
	id = null;
	unit_price = null;
	unit_discount = null;
	unit_discount_percentage = null;
	course_id = null;
	payment_contract_item_type_id = null;
	quantity = 1;
	loyalty_discount = null;
	payment_contract_id = null;
	total = null;
	total_bruto = null;
	vat_total = null;
	tax = 25;
	item_type = {};
	loyalty_discount = false;
	loyalty_points_usage = false;
	vat_exists = true;
	payment_contract_item_type = {};
	course = {};
	active = true;

	constructor(data, validation = false) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}

		if (validation) {
			for (const [key, value] of Object.entries(this)) {
				this[key] = true;
			}
		}
	}
}

export default PaymentContractItem;
